"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { sendGTMEvent } from "@next/third-parties/google";
import { useCarFilters } from "@/hooks/useCarFilters";
import { useClientSearch } from "@/actions/clientSearchActions";
import { SearchInput } from "@/components/cars/SearchInputOptimized";
import QuickFilters from "./QuickFilters";
import SortingControls from "@/components/cars/SortingControls";
import { useMobileFilter } from "./MobileFilterProvider";
interface TopSearchBarProps {
  className?: string;
}
export default function TopSearchBar(t0) {
  const $ = _c(31);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    showMobileFilters,
    setShowMobileFilters
  } = useMobileFilter();
  const {
    searchQuery,
    hasActiveFilters
  } = useCarFilters();
  const {
    performSearch,
    isSearching
  } = useClientSearch();
  const [localSearchInput, setLocalSearchInput] = useState(searchQuery);
  const skipNextSyncRef = useRef(false);
  let t2;
  let t3;
  if ($[0] !== searchQuery) {
    t2 = () => {
      if (skipNextSyncRef.current) {
        skipNextSyncRef.current = false;
        return;
      }
      setLocalSearchInput(searchQuery);
    };
    t3 = [searchQuery];
    $[0] = searchQuery;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== localSearchInput || $[4] !== performSearch) {
    t4 = () => {
      sendGTMEvent({
        event: "search",
        search_term: localSearchInput,
        search_location: "top_search_bar",
        has_search_term: Boolean(localSearchInput.trim())
      });
      performSearch(localSearchInput, true);
      setLocalSearchInput("");
      skipNextSyncRef.current = true;
    };
    $[3] = localSearchInput;
    $[4] = performSearch;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleSearch = t4;
  let t5;
  if ($[6] !== setShowMobileFilters) {
    t5 = t6 => {
      const label = t6 === undefined ? "all" : t6;
      sendGTMEvent({
        event: "filter_toggle",
        filter_type: label,
        location: "top_search_bar"
      });
      setShowMobileFilters(true);
    };
    $[6] = setShowMobileFilters;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const openFilters = t5;
  const t6 = `t-border-b t-border-slate-200 t-bg-white ${className}`;
  let t7;
  if ($[8] !== handleSearch || $[9] !== isSearching || $[10] !== localSearchInput) {
    t7 = <div><div className="t-flex t-items-center t-gap-2"><div className="t-min-w-0 t-flex-1"><SearchInput value={localSearchInput} onChange={setLocalSearchInput} onSearch={handleSearch} placeholder="Search make, model, or keyword" isSearching={isSearching} aria-label="Search for cars" /></div></div></div>;
    $[8] = handleSearch;
    $[9] = isSearching;
    $[10] = localSearchInput;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <QuickFilters className="t-hidden t-overflow-x-auto t-pb-0.5 lg:t-flex" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== openFilters) {
    t9 = () => openFilters();
    $[13] = openFilters;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SlidersHorizontal className="t-h-4 t-w-4" aria-hidden="true" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== hasActiveFilters) {
    t11 = hasActiveFilters && <span className="t-h-2 t-w-2 t-rounded-full t-bg-brand-highlighter" aria-label="Filters applied" />;
    $[16] = hasActiveFilters;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== showMobileFilters || $[19] !== t11 || $[20] !== t9) {
    t12 = <button type="button" onClick={t9} aria-haspopup="dialog" aria-expanded={showMobileFilters} className="t-inline-flex t-min-h-11 t-items-center t-justify-center t-gap-2 t-rounded-none t-border t-border-brand-violet t-bg-brand-violet t-px-3 t-text-sm t-font-semibold t-text-white t-whitespace-nowrap t-transition-colors hover:t-bg-brand-violet-dark focus-visible:t-outline-none focus-visible:t-ring-2 focus-visible:t-ring-brand-violet focus-visible:t-ring-offset-2 lg:t-hidden">{t10}Shop Your Way{t11}</button>;
    $[18] = showMobileFilters;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="t-flex-shrink-0 t-self-end sm:t-self-auto"><SortingControls /></div>;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12) {
    t14 = <div className="t-mt-2 t-flex t-items-center t-justify-between t-gap-2 lg:t-mt-3">{t8}{t12}{t13}</div>;
    $[23] = t12;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t14 || $[26] !== t7) {
    t15 = <div className="t-px-4 t-py-3 lg:t-py-4 sm:t-px-6 lg:t-px-8">{t7}{t14}</div>;
    $[25] = t14;
    $[26] = t7;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15 || $[29] !== t6) {
    t16 = <div className={t6}>{t15}</div>;
    $[28] = t15;
    $[29] = t6;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}